export default __webpack_public_path__ + "static/media/no_payment_methods.fae7a04f.svg";